/**
 * Llamadas a la API de preferencias de correo (CDT-219).
 *
 * `destino` es `'yo'` (las propias, `/cuenta/correos`, cualquier rol) o el id de otra persona
 * (`/usuarios/:id/correos`, solo ADMIN: la API responde 403 a los demás).
 */
import {
  avisosPorPersonaSchema,
  preferenciasCorreoSchema,
  type AvisosCorreo,
  type GuardarPreferenciasCorreoEntrada,
} from '@cdtec-backlog/contrato';
import { solicitar } from '../../lib/api';

export type DestinoCorreos = 'yo' | number;

const ruta = (destino: DestinoCorreos) =>
  destino === 'yo' ? '/cuenta/correos' : `/usuarios/${destino}/correos`;

export const obtenerCorreos = (destino: DestinoCorreos) =>
  solicitar(ruta(destino), { esquema: preferenciasCorreoSchema });

/** PUT completo: siempre los cuatro avisos más `propios`. */
export const guardarCorreos = (destino: DestinoCorreos, avisos: AvisosCorreo) => {
  const cuerpo: GuardarPreferenciasCorreoEntrada = { avisos };
  return solicitar(ruta(destino), { metodo: 'PUT', cuerpo, esquema: preferenciasCorreoSchema });
};

/** Avisos de todas las personas, por id (Personas; solo ADMIN). */
export const listarAvisosDePersonas = () =>
  solicitar('/usuarios/correos', { esquema: avisosPorPersonaSchema });
